// Central brand palette
export const BRAND = {
  bg: "#07111f",
  bgDeep: "#050b14",
  panel: "rgba(255,255,255,0.07)",
  line: "rgba(255,255,255,0.14)",
  text: "#f4f8fb",
  muted: "#b8c7d9",
  accent: "#4de1c1",
  accent2: "#6aa8ff",
  warning: "#ffd166",
  danger: "#ff6b6b",
  darkInk: "#06111d",
  shadow: "0 24px 80px rgba(0,0,0,0.36)",
  logo: "/portal/netdefenders-brand/netdefenders-white-horizontal.png",
  icon: "/portal/netdefenders-brand/netdefenders-icon-full-color-512.png",
  cream: "#f4f8fb",
  orange: "#4de1c1",
  purple: "#6aa8ff",
  darkBlue: "#07111f",
};
